import { render } from "./NavMenu.vue?vue&type=template&id=29edf0f2"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=29edf0f2&lang=css"
script.render = render

export default script